import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { LoadingService } from '../../../shared/services/loading.service';
import { UserService } from '../../../shared/services/user.service';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '../../../../app/translate';
import { Subscription } from 'rxjs/Subscription';
import { TemperatureInspectionVM, TemperatureForPinsVM } from '../temperature-inspection.module';  
import { TemperatureInspectionService } from '../temperature-inspection.service';
import { Router } from '@angular/router';
import { SelectionLists, Customer, CurrentSelection, JobSite, Equipment } from '../../../entities';
import { AppService } from '../../../app.service';
import { Observable } from 'rxjs/Observable';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-create-new-temperature-inspection',
  templateUrl: './create-new-temperature-inspection.component.html',
  styleUrls: ['./create-new-temperature-inspection.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class CreateNewTemperatureInspectionComponent implements OnInit {

  public todate = new Date();

  
  isInspector:boolean=false;
  dateReplaced: Date = new Date();
  translateSubscription:Subscription;
  userLanguage = 'english';
  EquipmentSetupDate:string;
  selectedSMU:number;
  ambientTemp:number;
  equipmentId:number;
 
  pinTemL:number;
  pinNOL:number=1;

  pinTemR:number;
  pinNOR:number=1;

  model:string;
  selectedSide:number;

pinTemperatureL:TemperatureForPinsVM = new  TemperatureForPinsVM();
pinTemperatureListL:TemperatureForPinsVM[]=[];

pinTemperatureR:TemperatureForPinsVM = new  TemperatureForPinsVM();
pinTemperatureListR:TemperatureForPinsVM[]=[];

EnableStartInspection:boolean=false;
pinCount:number;
hasEquipment:boolean=true;

_dropDownLists: SelectionLists = new SelectionLists();
_dropDownListsFiltered: SelectionLists = new SelectionLists();
_currentSelection: CurrentSelection = new CurrentSelection();
selectedJobsite: JobSite;
equipmentSelected: boolean;
isloading = true;
isValid:boolean=true;
DoneInspection:boolean=false;
  constructor(private _loading: LoadingService,
    private _userService: UserService,
    public dialogRef: MatDialogRef<CreateNewTemperatureInspectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _manageService: ManageEquipmentService,
    private _notification: NotificationsService,
    private _translate: TranslateService,private ref: ChangeDetectorRef, 
    private  _temperatureService: TemperatureInspectionService,
    private _router: Router,private _appService: AppService,
) { }

  ngOnInit() {

    this.loadUserJobRoles();
    this.CheckAddNewIspectionMenuAccess();
   this.EquipmentSetupDate= this.data.eqSetupDate;
   this.equipmentId=this.data.equipmentId;
   this.model= this.data.model;
   console.log("Date", this.data)
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
    
    this.selectedSide=1;
    if(this.data.equipmentId == null || this.data.equipmentId==undefined || this.data.equipmentId==0){
        this.hasEquipment=false;
    
    this.isloading = true;
    const customers = this._appService.getCustomerListForSelection(1, 10000);
    const jobsites = this._appService.getJobSiteListForSelection(1, 10000);
    const equipments = this._appService.getEquipmentListForSelection(1, 10000);

    Observable.forkJoin([customers, jobsites, equipments]).subscribe(results => {
      this._dropDownLists.customerList = results[0];
      this._dropDownListsFiltered.customerList = results[0];
      this._dropDownLists.jobSiteList = results[1];
      this._dropDownLists.equipmentList = results[2];
      this._loading.finishedLoading();
      this.isloading = false;
    });
  }else{
    this.getNumberofPins();
  }
  }

  getNumberofPins(){
    if(this.model!=null){
      this._temperatureService.getTemperatureInspectionPins(this.model).subscribe(res=>{
        this.pinCount=res;
        //this.pinCount=5;
      });
    }else{
      this._temperatureService.getTemperatureInspectionPinsByEquipmentId(this.equipmentId).subscribe(res=>{
        this.pinCount=res;
        //this.pinCount=5;
      });
      
    }
     
  }


  customerChanged(event: any): void {
    const customer: Customer = event.value;
    if (!customer) return;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId === customer.Id);
    this._currentSelection.jobSite = new JobSite();
    this._dropDownListsFiltered.equipmentList = [];
    this._currentSelection.equipment = new Equipment();
    this.equipmentSelected = false;
  }

  jobsiteChanged(event: any): void {
    const jobsite: JobSite = event.value;
    if (!jobsite) return;
    this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId === jobsite.Id);
    this._currentSelection.equipment = new Equipment();
    this.equipmentSelected = false;
  }
  equipmentChanged(event: any): void {
    this.equipmentId= event.value.Id;
    this.equipmentSelected = true;
    this.getNumberofPins();
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  onNoClick() {
    this.dialogRef.close();
  }


  CheckAddNewIspectionMenuAccess(){
    this._userService.CheckAddNewIspectionMenuAccess().subscribe(res=>{
      if(res==true){
        this.isInspector = true;
      }else{
        this.isInspector = false;
      }
    })
  }
  loadUserJobRoles() {
    this._loading.startLoading();
    this._userService.getUserJobRoles().subscribe(roles => {
        roles.forEach(r => {
            switch (r.Name) {
                case 'Inspectors':
                    this.isInspector = true;
                    break;
                case 'Interpreters':
                    this.isInspector = true;
                    break;
                case 'Super User':
                case 'Administrator':
                    this.isInspector = true;
                    break;
                    case 'Customer Admin':
                      this.isInspector = true;
                      break;
            }
        });

        this._loading.finishedLoading();
    });
  }
  SkipL(){
    this.selectedSide =2;
  }
  SkipR(){
    this.selectedSide =1;
  }
 Validate:boolean=true;
 ShowSkipL:boolean=false;
 ShowSkipR:boolean=false;




AddAndGotoRight(){

  if(this.pinTemL== undefined || this.pinTemL == null){
    this.Validate=false;
  }else{
    this.Validate=true;
    this.pinTemperatureL =  new TemperatureForPinsVM();
    this.pinTemperatureL.PinNo = this.pinNOL;
    this.pinTemperatureL.temperature=this.pinTemL;

    this.pinTemperatureListL.push(this.pinTemperatureL);

   
    this.selectedSide=2;
  }

}

AddAndGotoLeft(){

  if(this.pinTemR== undefined || this.pinTemR == null){
    this.Validate=false;
  }else{
    this.Validate=true;
    this.pinTemperatureR=  new TemperatureForPinsVM();
    this.pinTemperatureR.PinNo = this.pinNOR;
    this.pinTemperatureR.temperature=this.pinTemR;

    this.pinTemperatureListR.push(this.pinTemperatureR);
 }

   
    this.selectedSide=1;
  }


  SavePinTempRAndDone(){

    
  var temp = new TemperatureInspectionVM()
  {
    temp.InspectionDate =this.dateReplaced; //this.dateReplaced.toLocaleString();
    temp.AmbientTem=this.ambientTemp;
    temp.EquipmentId =this.equipmentId;
    temp.PinTemperatureL=this.pinTemperatureListL;
    temp.PinTemperatureR=this.pinTemperatureListR;
    temp.SMU=this.selectedSMU;
  }
  this._temperatureService.ValidateSMUAndDate(temp).subscribe(result=>{
    if (result.m_Item1) {
      console.log("result11111 Righ", result)
      this.SMUValidate=true;
      if(this.pinTemR== undefined || this.pinTemR == null){
        this.Validate=false;
      }else{
        this.Validate=true;
        this.pinTemperatureR=  new TemperatureForPinsVM();
        this.pinTemperatureR.PinNo = this.pinNOR;
        this.pinTemperatureR.temperature=this.pinTemR;
    
        this.pinTemperatureListR.push(this.pinTemperatureR);
     }
    
     if(this.Validate==true){
       this.SaveTemperatureInspection();
     }
     }
     else {
       this.SMUValidate=false;
       this._notification.warn('Failed', result.m_Item2);
       this.dialogRef.disableClose=true;
     }
  }) 
  }
SavePinTempLAndDone(){
  var temp = new TemperatureInspectionVM()
  {
    temp.InspectionDate = this.dateReplaced;//this.dateReplaced.toLocaleString();
    temp.AmbientTem=this.ambientTemp;
    temp.EquipmentId =this.equipmentId;
    temp.PinTemperatureL=this.pinTemperatureListL;
    temp.PinTemperatureR=this.pinTemperatureListR;
    temp.SMU=this.selectedSMU;
  }
  this._temperatureService.ValidateSMUAndDate(temp).subscribe(result=>{
    if (result.m_Item1) {
      console.log("result11111", result)
      this.SMUValidate=true;
      if(this.pinTemL== undefined || this.pinTemL == null){
        this.Validate=false;
      }else{
        this.Validate=true;
        this.pinTemperatureL =  new TemperatureForPinsVM();
        this.pinTemperatureL.PinNo = this.pinNOL;
        this.pinTemperatureL.temperature=this.pinTemL;
    
        this.pinTemperatureListL.push(this.pinTemperatureL);
     }
  
     if(this.Validate==true){
      this.SaveTemperatureInspection();
    }
     }
     else {
       this.SMUValidate=false;
       this._notification.warn('Failed', result.m_Item2);
       this.dialogRef.disableClose=true;
     }
  }) 
  }
  


SkipRAndDone(){
  var temp = new TemperatureInspectionVM()
  {
    temp.InspectionDate = this.dateReplaced;//this.dateReplaced.toLocaleString();
    temp.AmbientTem=this.ambientTemp;
    temp.EquipmentId =this.equipmentId;
    temp.PinTemperatureL=this.pinTemperatureListL;
    temp.PinTemperatureR=this.pinTemperatureListR;
    temp.SMU=this.selectedSMU;
  }
  this._temperatureService.ValidateSMUAndDate(temp).subscribe(result=>{
    if (result.m_Item1) {
      this.SMUValidate=true;
      this.SaveTemperatureInspection();
     }
     else {
       this.SMUValidate=false;
       this._notification.warn('Failed', result.m_Item2);
       this.dialogRef.disableClose=true;
     }
  })
 
}

SkipLAndDone(){
  var temp = new TemperatureInspectionVM()
  {
    temp.InspectionDate = this.dateReplaced;//this.dateReplaced.toLocaleString();
    temp.AmbientTem=this.ambientTemp;
    temp.EquipmentId =this.equipmentId;
    temp.PinTemperatureL=this.pinTemperatureListL;
    temp.PinTemperatureR=this.pinTemperatureListR;
    temp.SMU=this.selectedSMU;
  }
  this._temperatureService.ValidateSMUAndDate(temp).subscribe(result=>{
    if (result.m_Item1) {
      this.SMUValidate=true;
      this.SaveTemperatureInspection();
     }
     else {
       this.SMUValidate=false;
       this._notification.warn('Failed', result.m_Item2);
       this.dialogRef.disableClose=true;
     }
  })
}

SavePinTempL(){

  // if(this.pinTemperatureListL.length == this.pinCount+1){
  //   this.ShowSkipL=true;
  // }
  if(this.pinTemperatureListL.length==this.pinCount){
    //this.EnableStartInspection=true;
    this.Validate=true;
    
  }else{
    if(this.pinTemL== undefined || this.pinTemL == null){
      this.Validate=false;
    }else{
      this.Validate=true;
      this.pinTemperatureL =  new TemperatureForPinsVM();
      this.pinTemperatureL.PinNo = this.pinNOL;
      this.pinTemperatureL.temperature=this.pinTemL;

      this.pinTemperatureListL.push(this.pinTemperatureL);
      //this.EnableStartInspection=false;
      if(this.pinNOL != this.pinCount){
        this.pinNOL= this.pinNOL+1;
        this.pinTemL = null;
      }
     
    }
  }
    if(this.pinTemperatureListR.length>=this.pinCount-1 && this.pinTemperatureListL.length>=this.pinCount-1){
      this.EnableStartInspection=true;

    }else{
      this.EnableStartInspection=false;
    }
}

SavePinTempR(){
  // if(this.pinTemperatureListR.length >= this.pinCount-1){
  //   this.ShowSkipR=true;
  // }
  if(this.pinTemperatureListR.length==this.pinCount){
    //this.EnableStartInspection=true;
    this.Validate=true;
   
  }else{
    if(this.pinTemR== undefined || this.pinTemR == null){
      this.Validate=false;
    }else{
      this.Validate=true;
      this.pinTemperatureR=  new TemperatureForPinsVM();
      this.pinTemperatureR.PinNo = this.pinNOR;
      this.pinTemperatureR.temperature=this.pinTemR;

      this.pinTemperatureListR.push(this.pinTemperatureR);
      //this.EnableStartInspection=false;
      if(this.pinNOR != this.pinCount){
        this.pinNOR= this.pinNOR+1;
        this.pinTemR = null;
      }

    }
  }
    console.log("this.pinTemperatureListRight.", this.pinTemperatureListR)

    if(this.pinTemperatureListR.length>=this.pinCount-1 && this.pinTemperatureListL.length>=this.pinCount-1){
      this.EnableStartInspection=true;
    }else{
      this.EnableStartInspection=false;
    }
}

SMUValidate:boolean;

SaveTemperatureInspection(){
  console.log("date", this.dateReplaced, "SMU", this.selectedSMU ,"ambientTemp", this.ambientTemp)

  if(this.selectedSMU==null || this.selectedSMU<0){
    this.isValid=false;
  }else{
    
  var temp = new TemperatureInspectionVM()
  {
    temp.InspectionDate = this.dateReplaced;//this.dateReplaced.toLocaleString();
    temp.AmbientTem=this.ambientTemp;
    temp.EquipmentId =this.equipmentId;
    temp.PinTemperatureL=this.pinTemperatureListL;
    temp.PinTemperatureR=this.pinTemperatureListR;
    temp.SMU=this.selectedSMU;
  }
  
  console.log("temp", temp)

  
this._temperatureService.CreateTemperatureInspection(temp).subscribe(result=>{
  console.log("result", result)
  if (result.m_Item1 > 0) {
   let inspectionId = result.m_Item1;
    this._notification.success('Success', result.m_Item2);
    this.dialogRef.close(true);
    this._router.navigate(['tempinspection', this.equipmentId , inspectionId]);
  }
  else {
    this._notification.warn('Failed', result.m_Item2);
    this.dialogRef.disableClose=true;
  }
  }, error => console.error(error), () => {  });

}
}
}
